import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function submitContactInfoAPI(contactInfo) {
  const url = `${AWS_API_URL}/contact-us`;
  return postRequest(url, contactInfo, await authorize());
}
